export interface BusinessProfile {
  id: string;
  name: string;
  primarySector: string;
  subSector: string;
  businessLexicon: string;
  category: string;
  risks: string[];
  trends: string[];
}

export const businessProfiles: BusinessProfile[] = [
  {
    id: 'ecogreen-foods',
    name: 'EcoGreen Foods',
    primarySector: 'Agriculture',
    subSector: 'Organic Farming and Distribution',
    category: 'Agriculture',
    businessLexicon: `Crop Management: Irrigation, Soil Health, Pest Control, Harvesting, Yield Optimization
Supply Chain: Logistics, Vendor Sourcing, Cold Storage, Distribution Networks, Inventory Tracking
Sustainability Practices: Carbon Footprint, Waste Reduction, Renewable Energy, Biodiversity, Water Conservation
Marketing: Branding, E-commerce, Consumer Engagement, Packaging Design, Market Research
Compliance: Food Safety Standards, Organic Certification, Labor Regulations, Environmental Audits, Export Guidelines`,
    risks: [
      'Climate Change Impacts',
      'Supply Chain Disruptions',
      'Regulatory Changes in Food Safety',
    ],
    trends: [
      'Rise of Plant-Based Alternatives',
      'Adoption of Precision Agriculture Tech',
      'Consumer Demand for Ethical Sourcing',
    ],
  },
  {
    id: 'fittrack-health',
    name: 'FitTrack Health',
    primarySector: 'Health and Wellness',
    subSector: 'Consumer Electronics and Apps',
    category: 'Health and Wellness',
    businessLexicon: `Product Development: Hardware Design, Software Integration, User Interface, Battery Life, Data Analytics
Customer Engagement: App Updates, Feedback Loops, Subscription Models, Personalization, Community Building
Data Management: Privacy Compliance, Cloud Storage, AI Algorithms, Health Metrics, User Profiles
Manufacturing: Component Sourcing, Assembly Lines, Quality Assurance, Prototyping, Scaling Production
Sales and Marketing: Digital Ads, Influencer Partnerships, Retail Channels, Pricing Strategy, Customer Retention`,
    risks: [
      'Data Privacy Breaches',
      'Market Saturation',
      'Supply Chain Shortages for Chips',
    ],
    trends: [
      'Integration with AI Health Coaching',
      'Growth in Remote Monitoring Devices',
      'Shift to Mental Health Tracking Features',
    ],
  },
  {
    id: 'urbanmobility-solutions',
    name: 'UrbanMobility Solutions',
    primarySector: 'Transportation',
    subSector: 'Shared Mobility and EVs',
    category: 'Transportation',
    businessLexicon: `Fleet Operations: Vehicle Maintenance, Charging Infrastructure, GPS Tracking, Route Optimization, Insurance Coverage
User Experience: App Booking, Payment Processing, Ride Sharing, Customer Support, Loyalty Programs
Sustainability: Battery Recycling, Emission Reduction, Green Energy Sourcing, Urban Planning Integration, Carbon Credits
Regulatory Compliance: Licensing, Safety Standards, Data Protection Laws, Traffic Regulations, Tax Incentives
Business Growth: Expansion Planning, Partnership Deals, Funding Rounds, Market Analysis, Competitor Benchmarking`,
    risks: [
      'Battery Supply Volatility',
      'Regulatory Shifts in EV Policies',
      'Cybersecurity Threats to Apps',
    ],
    trends: [
      'Autonomous Vehicle Advancements',
      'Rise of Micro-Mobility Options',
      'Government Subsidies for Green Transport',
    ],
  },
  {
    id: 'creativemedia-agency',
    name: 'CreativeMedia Agency',
    primarySector: 'Media and Entertainment',
    subSector: 'Advertising and Content Marketing',
    category: 'Media and Entertainment',
    businessLexicon: `Content Production: Scriptwriting, Video Editing, Graphic Design, Photography, Audio Mixing
Client Management: Project Briefing, Contract Negotiation, Timeline Tracking, Feedback Sessions, Invoice Processing
Digital Tools: Social Media Platforms, Analytics Software, SEO Optimization, Content Management Systems, Collaboration Apps
Marketing Strategies: Campaign Planning, Audience Targeting, Viral Trends, ROI Measurement, Brand Storytelling
Legal and Ethics: Copyright Clearance, Diversity Inclusion, Data Usage Rights, Ad Compliance, Freelancer Contracts`,
    risks: [
      'Algorithm Changes on Social Platforms',
      'Intellectual Property Disputes',
      'Economic Downturns Affecting Ad Spend',
    ],
    trends: [
      'AI-Generated Content Tools',
      'Short-Form Video Dominance',
      'Influencer Marketing Evolution',
    ],
  },
];

